import { Reducer } from 'redux';
import { OpsTasksState, OpsTasksStatus } from './OpsTasksState';
import {
    OPS_TASKS_RESET_ACTION_TYPE,
    OPS_TASKS_FETCH_START_ACTION_TYPE,
    OPS_TASKS_FETCH_SUCCESS_ACTION_TYPE,
    OPS_TASKS_FETCH_COUNTS_SUCCESS_ACTION_TYPE,
    OPS_TASKS_SAVE_START_ACTION_TYPE,
    OPS_TASKS_SAVE_SUCCESS_ACTION_TYPE,
    OPS_TASKS_DELETE_START_ACTION_TYPE,
    OPS_TASKS_DELETE_SUCCESS_ACTION_TYPE,
    OPS_TASKS_UPDATE_STATUS_START_ACTION_TYPE,
    OPS_TASKS_UPDATE_STATUS_SUCCESS_ACTION_TYPE,
    OPS_TASKS_BULK_COMPLETE_START_ACTION_TYPE,
    OPS_TASKS_BULK_COMPLETE_SUCCESS_ACTION_TYPE,
    OPS_TASKS_ERROR_ACTION_TYPE,
    OpsTasksAction
} from 'actions/opsTasks/OpsTasksActionsTypes';

const emptyCounts = { todo: 0, inProgress: 0, pastDue: 0, completed: 0, all: 0 };

const initialState: OpsTasksState = {
    tasks: [],
    counts: emptyCounts,
    filters: {},
    page: 1,
    size: 25,
    totalPages: 0,
    totalRecords: 0,
    status: OpsTasksStatus.Initial,
    loading: false,
    saving: false
};

export const opsTasksReducer: Reducer<OpsTasksState, OpsTasksAction> = (state = initialState, action) => {
    switch (action.type) {
        case OPS_TASKS_RESET_ACTION_TYPE:
            return {
                ...initialState
            };
        case OPS_TASKS_FETCH_START_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.Fetching,
                loading: true,
                filters: action.payload.filters,
                page: action.payload.page,
                size: action.payload.size
            };
        case OPS_TASKS_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.FetchSuccess,
                loading: false,
                tasks: action.payload.result.tasks,
                page: action.payload.result.page,
                size: action.payload.result.size,
                totalPages: action.payload.result.totalPages,
                totalRecords: action.payload.result.totalRecords
            };
        case OPS_TASKS_FETCH_COUNTS_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                counts: action.payload.counts
            };
        case OPS_TASKS_SAVE_START_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.Saving,
                saving: true
            };
        case OPS_TASKS_SAVE_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.SaveSuccess,
                saving: false,
                savedTask: action.payload.savedTask,
                tasks: state.tasks.map(task =>
                    task.id === action.payload.savedTask.id ? action.payload.savedTask : task
                )
            };
        case OPS_TASKS_DELETE_START_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.Deleting,
                loading: true,
                // Optimistic removal; the follow-up refetch reconciles pagination/counts.
                tasks: state.tasks.filter(task => task.id !== action.payload.deletedTaskId)
            };
        case OPS_TASKS_DELETE_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.DeleteSuccess,
                loading: false,
                tasks: state.tasks.filter(task => task.id !== action.payload.deletedTaskId)
            };
        case OPS_TASKS_UPDATE_STATUS_START_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.UpdatingStatus,
                // Optimistic status change so the row selector reflects instantly.
                tasks: state.tasks.map(task =>
                    task.id === action.payload.taskId ? { ...task, status: action.payload.status } : task
                )
            };
        case OPS_TASKS_UPDATE_STATUS_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.UpdateStatusSuccess,
                tasks: state.tasks.map(task => (task.id === action.payload.task.id ? action.payload.task : task))
            };
        case OPS_TASKS_BULK_COMPLETE_START_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.BulkCompleting,
                loading: true
            };
        case OPS_TASKS_BULK_COMPLETE_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.BulkCompleteSuccess,
                loading: false
            };
        case OPS_TASKS_ERROR_ACTION_TYPE:
            return {
                ...state,
                status: OpsTasksStatus.Error,
                loading: false,
                saving: false,
                error: action.payload.error
            };
        default:
            return state;
    }
};

export default opsTasksReducer;
